export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const fetchHealth = async () => {
  const response = await fetch(`${API_BASE_URL}/health`, { credentials: 'include' });
  return response.json();
};

export const getApiUrl = (endpoint) => `${API_BASE_URL}${endpoint}`; 